module.exports = __webpack_public_path__ + "images/emoji/smile_cat.600ad74f85ecf70c388c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smile_cat.png
// module id = joWT
// module chunks = 2